import React from 'react';
import cn from 'classnames';

import { TabItemPropsType } from '../atoms/TabItem';
import RightItem from '../organisms/TopBar/RightItem';

import Styles from './KDSTopbar.module.scss';

type KDSTopBarPropsType = {
	// rightside button items.
	rightItems?: Array<React.ReactElement<typeof RightItem>>;
};

const KDSTopBar: React.FC<KDSTopBarPropsType> = ({ rightItems }) => {
	return (
		<div className={cn('colK', 'colK12', Styles.headerContainer)}>
			<div
				className={cn(
					'rowK',
					Styles.firstRowContainer,
				)}
			>
				<div className={cn('rowK', Styles.KDSrow)}>{rightItems}</div>
			</div>
		</div>
	);
};

export default KDSTopBar;
